
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Auth() {
  const navigate = useNavigate();
  const [isLogin, setIsLogin] = useState(true);
  const [phone, setPhone] = useState('');
  const [name, setName] = useState('');
  const [city, setCity] = useState('');
  const [otp, setOtp] = useState('');
  const [showOtp, setShowOtp] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!showOtp) {
      setShowOtp(true);
    } else {
      navigate('/home');
    }
  };

  const handleGuestLogin = () => {
    navigate('/home');
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* الهيدر */}
      <div className="bg-green-500 pt-12 pb-8 px-6 text-center">
        <div className="w-16 h-16 mx-auto mb-4 bg-white rounded-full flex items-center justify-center">
          <i className="ri-shopping-cart-2-fill text-2xl text-green-500"></i>
        </div>
        <h1 className="text-2xl font-bold text-white mb-2">سلة البقالة</h1>
        <p className="text-white/80">
          {isLogin ? 'مرحباً بعودتك' : 'انضم إلينا اليوم'}
        </p>
      </div>

      {/* النموذج */}
      <div className="flex-1 px-6 py-8">
        <form onSubmit={handleSubmit} className="space-y-6">
          {!showOtp ? (
            <>
              {!isLogin && (
                <div>
                  <label className="block text-gray-700 text-sm font-medium mb-2">
                    الاسم الكامل
                  </label>
                  <input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-right"
                    placeholder="أدخل اسمك الكامل"
                    required={!isLogin}
                  />
                </div>
              )}

              <div>
                <label className="block text-gray-700 text-sm font-medium mb-2">
                  رقم الجوال
                </label>
                <input
                  type="tel"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-right"
                  placeholder="05xxxxxxxx"
                  required
                />
              </div>

              {!isLogin && (
                <div>
                  <label className="block text-gray-700 text-sm font-medium mb-2">
                    المدينة
                  </label>
                  <select
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-right"
                    required={!isLogin}
                  >
                    <option value="">اختر المدينة</option>
                    <option value="riyadh">الرياض</option>
                    <option value="jeddah">جدة</option>
                    <option value="dammam">الدمام</option>
                    <option value="mecca">مكة المكرمة</option>
                    <option value="medina">المدينة المنورة</option>
                  </select>
                </div>
              )}
            </>
          ) : (
            <div>
              <label className="block text-gray-700 text-sm font-medium mb-2">
                رمز التحقق
              </label>
              <input
                type="text"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-center text-2xl tracking-widest"
                placeholder="0000"
                maxLength={4}
                required
              />
              <p className="text-gray-500 text-sm mt-2 text-center">
                تم إرسال رمز التحقق إلى {phone}
              </p>
            </div>
          )}

          <button
            type="submit"
            className="w-full bg-green-500 text-white py-3 rounded-lg font-medium hover:bg-green-600 transition-colors"
          >
            {showOtp ? 'تأكيد الرمز' : (isLogin ? 'تسجيل الدخول' : 'إنشاء حساب')}
          </button>
        </form>

        {!showOtp && (
          <>
            <div className="text-center mt-6">
              <button
                onClick={() => setIsLogin(!isLogin)}
                className="text-green-500 font-medium"
              >
                {isLogin ? 'ليس لديك حساب؟ إنشاء حساب جديد' : 'لديك حساب؟ تسجيل الدخول'}
              </button>
            </div>

            <div className="mt-8 pt-6 border-t border-gray-200">
              <button
                onClick={handleGuestLogin}
                className="w-full bg-gray-100 text-gray-700 py-3 rounded-lg font-medium hover:bg-gray-200 transition-colors"
              >
                متابعة كزائر
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
